import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '../services/settings.service';

@Component({
  standalone: false,
  selector: 'odin-odin-settings-page',
  templateUrl: './odin-settings-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./odin-settings-page.component.scss'],
})
export class OdinSettingsPageComponent {
  get themeName(): string {
    return this.settingsService.GetNotNullSetting<string>('themeName', 'light').value;
  }
  set themeName(themeName: string) {
    this.settingsService.SetSetting('themeName', themeName);
  }

  constructor(private settingsService: SettingsService,
    private router: Router,
    @Inject('themes') private themes: { view: string, value: string }[]) {
  }

  public themeOptions(): { view: string, value: string }[] {
    return this.themes;
  }
}
